import type React from "react";

import { iconComponentNames } from "./IconNames";
import type SvgIconReactProps from "./SvgIconReact.model";

export const IconComponent: React.FC<SvgIconReactProps> = ({ iconName, ...props }) => {
  const IconComponentTag = iconComponentNames[iconName];
  return <IconComponentTag {...props} />;
};
